import React, { useContext, useState } from "react";
import Navbar from "../../../../common/layout/Navbar";
import { empType, LicenseTypes } from "../../../../../utils/Enum.types";
import { AppProvider } from "../../maps/context/context";
import { Title } from "../../../../../stories/Title/Title";
import { Tab, Tabs } from "@mui/material";
import useLabels from "../../../../../customHooks/useLabels";
import { a11yProps, TabPanel } from "../../../../../styles/Tabs";
import SignalsTable from "../vendorwise/SignalsTable";
import SignalTypes from "./SignalTypes";
import VendorWise from "./VendorWise";
import { VendorListPageFor } from "../vendorwise/List";
import { AppContext } from "../../../../../context/context";

const SignalWiseIndex = () => {
  const [value, setValue] = useState(0);
  const { junctionLabel, ledgerLabel } = useLabels();
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const { state } = useContext(AppContext);
  const showNavbar =
    state.empSubType === empType.JCP ||
    state.empSubType === empType.PMU ||
    state.empSubType === empType.VENDOR_MANAGER ||
    state.empSubType === empType.HELP_DESK;

  return (
    <AppProvider>
      {showNavbar ? (
        <Navbar NavType={LicenseTypes.DASHBOARD} />
      ) : (
        <Navbar NavType={LicenseTypes.COMPANY} />
      )}
      <Title>Signal Reports</Title>
      <div className="signal-wise-report">
        <div className="signal-wise-report__tabs">
          <Tabs value={value} onChange={handleChange}>
            <Tab
              label={`${junctionLabel} Details`}
              value={0}
              {...a11yProps(0)}
            />

            <Tab label={`${junctionLabel} Types`} value={1} {...a11yProps(1)} />
            <Tab label={`${ledgerLabel}`} value={2} {...a11yProps(2)} />
          </Tabs>
        </div>
        <div className="signal-wise-report__tabpanel">
          <TabPanel value={value} index={0}>
            <SignalsTable pageType={VendorListPageFor.VENDOR_WISE} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <SignalTypes />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <VendorWise />
          </TabPanel>
        </div>
      </div>
    </AppProvider>
  );
};

export default SignalWiseIndex;
